import React from 'react';
import "./DetailSectionHeader.scss";

const DetailSectionHeader = (props) => {
	const { header, icon, className, id, iconEnd, headerClassName } = props;
	return (
		<div id={id} className={`detail-section-header${className? ' ' + className : ''}`}>
			{icon && icon}
			<h3 className={headerClassName}>{header}</h3>
			{iconEnd && iconEnd}
		</div>
	)
}

export default DetailSectionHeader;